import {
  LayoutDashboard,
  Library,
  Megaphone,
  Users,
  Palette,
  Settings,
  type LucideIcon,
} from 'lucide-react';

export interface AdminDestination {
  /** Slug used in /admin/<slug> URLs and as the chip key. */
  slug: string;
  /** Display name in the chip + page header. */
  label: string;
  /** 1-line marketing description for the mobile hub card. */
  description: string;
  /** Lucide icon rendered in the icon-badge. */
  icon: LucideIcon;
}

export const ADMIN_DESTINATIONS: readonly AdminDestination[] = [
  {
    slug: 'dashboard',
    label: 'Dashboard',
    description: 'Today at a glance — users, requests, signups.',
    icon: LayoutDashboard,
  },
  {
    slug: 'catalog',
    label: 'Catalog',
    description: 'Episodes and curated collections.',
    icon: Library,
  },
  {
    slug: 'publishing',
    label: 'Publishing',
    description: 'Changelogs and quotes.',
    icon: Megaphone,
  },
  {
    slug: 'users',
    label: 'Users',
    description: 'Directory and badges.',
    icon: Users,
  },
  {
    slug: 'appearance',
    label: 'Appearance',
    description: 'Themes shipped to users.',
    icon: Palette,
  },
  {
    slug: 'system',
    label: 'System',
    description: 'Site settings, partner links, OAuth clients.',
    icon: Settings,
  },
] as const;

export function destinationPathFor(slug: string): string {
  return slug === 'dashboard' ? '/admin' : `/admin/${slug}`;
}

export function destinationFromPath(pathname: string): AdminDestination | undefined {
  if (pathname === '/admin' || pathname === '/admin/') {
    return ADMIN_DESTINATIONS[0];
  }
  const slug = pathname.replace(/^\/admin\//, '').split('/')[0]?.split('?')[0];
  return ADMIN_DESTINATIONS.find((d) => d.slug === slug);
}
